import * as theme from "./theme/common";


export const scoreMap = theme.scoreMap;
export const levelMap = theme.levelMap;

